import { sortingStrategies } from './sortingStrategies';

const optionsFactoryKeys = { composite: 'composite', leaf: 'leaf' };
const entriesFactoryKeys = { floor: 'floor', room: 'room' };

const floorOptionsSchema = {
  porch: {
    type: optionsFactoryKeys.leaf,
    labelFn: (value) => `Подъезд ${value}`,
    sortStrategy: sortingStrategies.byFloors,
  },
};

const roomOptionsSchema = {
  porch: {
    type: optionsFactoryKeys.composite,
    labelFn: (value) => `Подъезд ${value}`,
    sortStrategy: sortingStrategies.bySortOrder,
  },
  floor: {
    type: optionsFactoryKeys.leaf,
    labelFn: (value) =>
      value.startsWith('-')
        ? `Подвал. Уровень ${value.slice(1)}`
        : `Этаж ${value}`,
    sortStrategy: sortingStrategies.bySortOrder,
  },
};

const optionSchemas = {
  floor: floorOptionsSchema,
  room: roomOptionsSchema,
};

export { optionsFactoryKeys, entriesFactoryKeys, optionSchemas };
